export const skypeEnterpriseCharm_ariaLabel = "SaFXzd";
export default {skypeEnterpriseCharm_ariaLabel};